import { createContext, useState } from 'react';
import { UploadImageEnum } from '../pages/UploadImage/UploadImage.enum';

export const UploadImageContext = createContext({} as any);

export const UploadImageProvider = ({ children }) => {
  const [uploadImageStep, setUploadImageStep] = useState(
    UploadImageEnum.CHOOSE_PROFILE_PICTURE
  );
  const [croppedImage, setCroppedImage] = useState(null);
  const [profileId, setProfileId] = useState(null);

  return (
    <UploadImageContext.Provider
      value={{
        uploadImageStep,
        setUploadImageStep,
        croppedImage,
        setCroppedImage,
        profileId,
        setProfileId,
      }}
    >
      {children}
    </UploadImageContext.Provider>
  );
};
